import React from 'react';
import { Text } from '@fluentui/react-components';
import { getShouldRenderConversationId } from './utils';

export interface ConversationIdProps {
  conversationId?: string;
  className?: string;
}

// Renders the active Copilot conversation id. No-op unless
// `?copilotchatdebug=1` is on the URL — see `getShouldRenderConversationId`.
//
// Lives in ads-copilot-ui so AdsCopilot (V2) and MSACopilot (V1) share a
// single render path. msa-copilot-common already depends on ads-copilot-ui,
// so no circular dep is introduced.
export const ConversationId: React.FC<ConversationIdProps> = ({ conversationId, className }) => {
  if (!conversationId) return null;
  if (!getShouldRenderConversationId(new URLSearchParams(window.location.search))) return null;
  return <Text className={className}>Conversation Id: {conversationId}</Text>;
};
